import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { TelephoneNumberInfo } from "@/clients/attnow/types";

export type VFCCSession = {
    state: VerificationState;
    message: string;
    ubid?: string;
    tnInfo?: TelephoneNumberInfo;
    tnInfoList?: TelephoneNumberInfo[];
};

export enum VerificationState {
    VERIFYING,
    VERIFIED,
    UNVERIFIED,
    ERROR,
}

interface VFCCSessionStore {
    vfccSession: VFCCSession;
    getVFCCSession: () => VFCCSession;
    setVFCCSession: (newState: VFCCSession) => void;
    verifying: () => void;
    clearVFCCSession: () => void;
}

const useVFCCSessionStore = create<VFCCSessionStore>()(
    persist(
        (set, get) => ({
            vfccSession: {
                state: VerificationState.UNVERIFIED,
                message: "",
            },
            getVFCCSession: () => get().vfccSession,
            setVFCCSession: (vfccSession) => set(() => ({ vfccSession })),
            verifying: () =>
                set((prev) => ({
                    ...prev,
                    state: VerificationState.VERIFYING,
                })),
            clearVFCCSession: () =>
                set(() => ({
                    vfccSession: {
                        state: VerificationState.UNVERIFIED,
                        message: "",
                    },
                })),
        }),
        {
            name: "vfccSession",
            storage: createJSONStorage(() => sessionStorage),
            skipHydration: true,
        },
    ),
);

export default useVFCCSessionStore;
